module.exports = __webpack_public_path__ + "img/3.11216c4d.png";